import { backendClient } from '../lib/api/backendClient';

export type FavoriteAction =
  | 'save'
  | 'unsave'
  | 'mute'
  | 'unmute';

export const favoriteActionEventsService = {
  async getBlockedEntities(
    entityType: string,
    entityIds: string[],
    options?: { blockedActions?: FavoriteAction[] }
  ): Promise<Set<string>> {
    if (!Array.isArray(entityIds) || entityIds.length === 0) {
      return new Set();
    }

    const normalizedIds = Array.from(
      new Set(
        entityIds
          .filter((id): id is string => typeof id === 'string')
          .map((id) => id.trim())
          .filter((id) => id.length > 0)
      )
    );

    if (normalizedIds.length === 0) {
      return new Set();
    }

    const payload: Record<string, unknown> = {
      entityType: typeof entityType === 'string' ? entityType.trim() : '',
      entityIds: normalizedIds
    };

    if (options?.blockedActions && options.blockedActions.length > 0) {
      payload.blockedActions = options.blockedActions;
    }

    const { data } = await backendClient.post<{ blockedIds?: string[] }>(
      '/favorites/blocks',
      payload
    );

    const ids = Array.isArray(data?.blockedIds)
      ? data.blockedIds
          .filter((id): id is string => typeof id === 'string')
          .map((id) => id.trim())
          .filter((id) => id.length > 0)
      : [];

    return new Set(ids);
  }
};
